import React from 'react';

import { useShipmentData } from './DataProviders';


export function DestinationAddress1() {
  const { destination } = useShipmentData();
  return <div className="address1">{destination.address}</div>;
}

export function DestinationAddress2() {
  const { destination } = useShipmentData();
  return (
    destination.address2 ? (
      <div className="address2">{destination.address2}</div>
    ):(
      null
    )
  );
}

export function DestinationCityStateZip({ className='' }) {
  const { destination } = useShipmentData();
  return <div className={`city-state-zip ${className}`} data-testid="destination-city-state-zip">
    {destination.city}, {destination.state} {destination.postal_code}
  </div>;
}

export default function DestinationAddress({ className='' }) {
  return <div className={className}>
    <DestinationAddress1 />
    <DestinationAddress2 />
    <DestinationCityStateZip />
  </div>;
}
